import $ from 'jquery'
import Component from './component'
import Cookies from 'js-cookie'

export class PrivacyPolicyBanner extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    Object.assign(this.classes, {
      button: '.js-privacy-ok',
    })

    Object.assign(this.classStates, {
      inactive: 'h-state--inactive',
      transition: 'h-state--transition',
      notAcceptedPrivacy: 'h-state--not-accepted-privacy',
    })

    this.$html = $('html')
    this.$button = this.$ctx.find(this.classes.button)

    this.displayIfNoCookie()
    this.bindings()
  }

  displayIfNoCookie() {
    if (!Cookies.get('acceptedPrivacy')) {
      this.$ctx.addClass(this.classStates.active)
      this.$html.addClass(this.classStates.notAcceptedPrivacy)
    }
  }

  bindings() {
    const DELAY = 500

    this.$button.on('click', (ev) => {
      ev.preventDefault()

      this.$ctx.addClass(this.classStates.transition)

      window.setTimeout(() => {
        this.$ctx.addClass(this.classStates.inactive)
        this.$html.removeClass(this.classStates.notAcceptedPrivacy)
      }, DELAY)

      Cookies.set('acceptedPrivacy', true, {
        expires: 30,
      })
    })
  }

  onResize() {
    // noop
  }
}
